<div class="content-div popup-wallboard-settings">
  <!-- <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
       <app-basic-button  type="secondary" isIcon="true" size="medium" (click)="openHelp('main')">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div> -->
  <div class="top-bar">
    <span class="page-header">
      {{ 'realtime:wallboard_SettingsHeader' | i18next : { defaultValue: 'Wallboard Settings' } }}
      <span *ngIf="model.impersonationActive">
        {{ 'realtime:YouAreImpersonatedAs' | i18next }} {{ model.impersonationName }}
      </span>
    </span>

    <span class="spacer"></span>
    <app-basic-button id="close-btn-wallboard-settings" type="secondary" isIcon="true" size="medium" (click)="closeDialog()" aria-label="Close">
      <i class="far fa-times fs-16"></i>
    </app-basic-button>
  </div>

  <div class="content popup-wallboard-settings-content">
    <!-- Wallboard Type Selection -->
    <fieldset class="wallboard-type-section">
      <div style="display: flex; flex-direction: row;    align-items: flex-end; gap: 64px;">
        <div class="wholewidth">
          <app-basic-radio id="radio-queue-wallboard-settings" [label]="'realtime:wallboard_queuewallboard' | i18next" [(ngModel)]="model.wallboardType"
            value="Queue" (change)="onWallboardTypeChange()"></app-basic-radio>
          <app-basic-radio id="radio-agent-wallboard-settings" [label]="'realtime:wallboard_agentwallboard' | i18next" [(ngModel)]="model.wallboardType"
            value="Agent" (change)="onWallboardTypeChange()"></app-basic-radio>
          <app-basic-radio id="radio-combined-wallboard-settings" [label]="'realtime:wallboard_combinedwallboard' | i18next" [(ngModel)]="model.wallboardType"
            value="Combined" (change)="onWallboardTypeChange()"></app-basic-radio>
        </div>
        <div>
          <span class="switch-text">
            {{ 'realtime:wallboard_switchtext' | i18next }}
            <app-basic-textbox id="switch-time-input-wallboard-settings" [(model)]="model.switchTime" (modelChange)="onSwitchTimeChange()" type="number" min="5"
              max="30" width="50px" size="small" class="switch-time-textbox"></app-basic-textbox>
            {{ 'realtime:wallboard_second' | i18next }}
          </span>
        </div>
      </div>
      <div class="actions">
        <app-basic-button id="undo-wallboard-type-btn-wallboard-settings" type="secondary" size="small" (click)="undoWallboardTypeChanges()" [disabled]="!hasWallboardTypeChanges">
          {{'Undo changes' | i18next }}
        </app-basic-button>
        <app-basic-button id="save-wallboard-type-btn-wallboard-settings" type="primary" size="small" (click)="saveWallboardTypeSettings()"[disabled]="!hasWallboardTypeChanges || switchError">
          {{ 'realtime:queuedetails_lang_savechanges' | i18next}}
        </app-basic-button>
      </div>
      <div class="error-pane" id="switchErrorPane" *ngIf="switchError">
        {{ switchError }}
      </div>
    </fieldset>

    <!-- Queue Settings Accordion -->
    <div class="accordion-section">
      <div class="accordion-header" (click)="toggleAccordion('queue')">
        <h3>
          <i class="fas fa-chevron-right dropdown-button" [class.rotate-down]="accordionStates.queue"></i>
          {{ 'realtime:wallboard_QueueSettings' | i18next }}
          <app-basic-button id="help-queue-btn-wallboard-settings" type="tertiary" isIcon="true" size="medium" (click)="openHelp('queue')" class="info-icon"
            dropShadow="false" aria-label="Help">
            <i class="fal far fa-info-circle fs-16"></i>
          </app-basic-button>
        </h3>
      </div>
      <div class="accordion-body" [style.display]="accordionStates.queue ? 'block' : 'none'">
        <form>
          <div class="form-section">
            <div class="form-group">
              <div class="dropdown-wrapper">
                <app-basic-dropdown id="queues-dropdown-wallboard-settings" [(model)]="selectedQueues" [label]="'realtime:wallboard_SelectQueues' | i18next " renderAsHtml="true"
                  [items]="model.queues" bindLabel="description" bindValue="id" (modelChange)="onQueueSelectionChange()"
                  width="100%" [multiple]="true" [multiline]="true"></app-basic-dropdown>
                <div class="dropdown-selected">{{selectedQueues?.length??"0"}} {{ 'realtime:selected' | i18next }}</div>
              </div>
              <div>
                  <app-basic-checkbox id="checkbox-show-in-queue-wallboard-settings" [label]="'realtime:wallboard_showInQueue' | i18next " [(model)]="model.checkInQueueAgent"
                  (modelChange)="onQueueSettingsChange()" ></app-basic-checkbox>
              </div>
              <div cdkDropList (cdkDropListDropped)="onQueueDrop($event)" class="sortable-list">
                <div *ngFor="let queue of sortedQueues;" cdkDrag class="sortable-item" [attr.data-id]="queue.id">
                  <img src="assets/Img/grip-dots-vertical.svg" class="icon-grip-dots" alt="Drag Handle" />
                  <span >{{queue.description | htmlDecode }}</span>
                </div>
              </div>
              <div class="dropdown-wrapper">
                <app-basic-dropdown id="columns-dropdown-wallboard-settings" [(model)]="selectedColumns" [label]="'realtime:wallboard_Selectcolumns' | i18next"
                  [translateItems]="true" translationNamespace="realtime" [items]="model.columns" bindLabel="item3"
                  bindValue="item1" (modelChange)="onColumnSelectionChange()" width="100%" [multiple]="true" appendTo=".popup-wallboard-settings"
                  [multiline]="true"></app-basic-dropdown>
                <div class="dropdown-selected">{{selectedColumns?.length??"0"}} {{ 'realtime:selected' | i18next }}
                </div>
              </div>
              <div class="warning-message" *ngIf="selectedColumns?.length>5">
                <i class="fas fa-exclamation-circle"></i>
                  {{ 'realtime:Some columns may not be visible due to limited table width. Check fullscreen mode, and remove columns if needed.' | i18next }}
              </div>
              <div class="sortable-container">
                <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onColumnDrop($event)"
                  class="mixed-sortable-list">
                  <div *ngFor="let column of sortedColumns" cdkDrag class="mixed-sortable-item"
                    [attr.data-id]="column.item1">
                    <img src="assets/Img/grip-dots-vertical.svg" class="icon-grip-dots" alt="Drag Handle" />
                    <div>{{ 'realtime:'+column.item3| i18next }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="actions">
          <app-basic-button id="undo-queue-btn-wallboard-settings" type="secondary" size="small" (click)="undoQueueChanges()" [disabled]="!hasQueueChanges">
            {{'Undo changes' | i18next }}
          </app-basic-button>
          <app-basic-button id="save-queue-btn-wallboard-settings" type="primary" size="small" (click)="saveQueueSettings()" [disabled]="!hasQueueChanges">
            {{ 'realtime:queuedetails_lang_savechanges' | i18next }}
          </app-basic-button>
        </div>
        <div class="error-pane" id="queueErrorPane" *ngIf="queueError"> {{ queueError }} </div>
      </div>
    </div>

    <!-- Agent Settings Accordion -->
    <div class="accordion-section">
      <div class="accordion-header" (click)="toggleAccordion('agent')">
        <h3>
          <i class="fas fa-chevron-right dropdown-button" [class.rotate-down]="accordionStates.agent"></i>
          {{ 'realtime:wallboard_agentSettings' | i18next }}
          <app-basic-button id="help-agent-btn-wallboard-settings" type="tertiary" isIcon="true" size="medium" (click)="openHelp('agent')" class="info-icon"
            dropShadow="false" aria-label="Help">
            <i class="fal far fa-info-circle fs-16"></i>
          </app-basic-button>
        </h3>
      </div>
      <div class="accordion-body" [style.display]="accordionStates.agent ? 'block' : 'none'">
        <form>
          <div class="form-section">
            <div class="form-group">
              <div class="dropdown-wrapper">
                <app-basic-dropdown id="agents-dropdown-wallboard-settings" [(model)]="selectedAgents" [label]="'realtime:wallboard_SelectAgents' | i18next"
                  [items]="model.agents" bindLabel="name" bindValue="userId" (modelChange)="onAgentSelectionChange()"
                  width="100%" [multiple]="true" [multiline]="true"></app-basic-dropdown>
                <div class="dropdown-selected">{{selectedAgents?.length??"0"}} {{ 'realtime:selected' | i18next }}</div>
              </div>
              <app-basic-checkbox id="checkbox-show-logon-agent-wallboard-settings" [label]="'realtime:wallboard_showlogonagent' | i18next " [(model)]="model.checkLogOnAgent"
                (modelChange)="onAgentSettingsChange()"></app-basic-checkbox>
              <div class="sortable-container">
                <div cdkDropList (cdkDropListDropped)="onAgentDrop($event)" class="sortable-list">
                  <div *ngFor="let agent of sortedAgents" cdkDrag class="sortable-item" [attr.data-id]="agent.userId">
                    <img src="assets/Img/grip-dots-vertical.svg" class="icon-grip-dots" alt="Drag Handle" />
                    {{ agent.name }}
                  </div>
                </div>
              </div>
              <div class="dropdown-wrapper">
                <app-basic-dropdown id="agent-columns-dropdown-wallboard-settings" [(model)]="selectedAgentColumns"
                  [label]="'realtime:wallboard_SelectAgentColumns' | i18next" [items]="model.agentColumns" appendTo=".popup-wallboard-settings"
                  bindLabel="item3" [translateItems]="true" translationNamespace="realtime" bindValue="item1"
                  (modelChange)="onAgentColumnSelectionChange()" width="100%" [multiple]="true"
                  [multiline]="true"></app-basic-dropdown>
                  <div class="dropdown-selected">{{selectedAgentColumns?.length??"0"}} {{ 'realtime:selected' | i18next }}
                </div>
              </div>
              <div class="warning-message" *ngIf="selectedAgentColumns?.length>5">
                <i class="fas fa-exclamation-circle"></i>
                  {{ 'realtime:Some columns may not be visible due to limited table width. Check fullscreen mode, and remove columns if needed.' | i18next }}
              </div>
              <div class="sortable-container">
                <div cdkDropList (cdkDropListDropped)="onAgentColumnDrop($event)" class="mixed-sortable-list"
                  cdkDropListOrientation="mixed">
                  <div *ngFor="let column of sortedAgentColumns" cdkDrag class="mixed-sortable-item"
                    [attr.data-id]="column.item1">
                    <img src="assets/Img/grip-dots-vertical.svg" class="icon-grip-dots" alt="Drag Handle" />
                    {{ 'realtime:'+column.item3 | i18next }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="actions">
          <app-basic-button id="undo-agent-btn-wallboard-settings" type="secondary" size="small" (click)="undoAgentChanges()" [disabled]="!hasAgentChanges">
            {{'Undo changes' | i18next }}
          </app-basic-button>
          <app-basic-button id="save-agent-btn-wallboard-settings" type="primary" size="small" (click)="saveAgentSettings()" [disabled]="!hasAgentChanges">
            {{'realtime:queuedetails_lang_savechanges' | i18next}}
          </app-basic-button>
        </div>
        <div class="error-pane" id="agentErrorPane" *ngIf="agentError">
          {{ agentError }}
        </div>
      </div>
    </div>

    <!-- Display Settings Accordion -->
    <div class="accordion-section">
      <div class="accordion-header" (click)="toggleAccordion('display')">
        <h3>
          <i class="fas fa-chevron-right dropdown-button" [class.rotate-down]="accordionStates.display"></i>
          {{ 'realtime:wallboard_DisplaySettings' | i18next }}
          <app-basic-button id="help-display-btn-wallboard-settings" type="tertiary" isIcon="true" size="medium" (click)="openHelp('display')" class="info-icon"
            dropShadow="false" aria-label="Help">
            <i class="fal far fa-info-circle fs-16"></i>
          </app-basic-button>
        </h3>
      </div>
      <div class="accordion-body" [style.display]="accordionStates.display ? 'block' : 'none'">

        <div class="form-section">
          <div class="form-group">
            <div class="form-row">
              <app-basic-dropdown id="logo-dropdown-wallboard-settings" [(model)]="model.logoId" [items]="model.logoItems" bindLabel="text" bindValue="value" width="600px" appendTo=".popup-wallboard-settings"
                [label]="'realtime:wallboard_Content_Logo' | i18next" (modelChange)="onDisplaySettingsChange()" ></app-basic-dropdown>
              <app-basic-textbox id="max-rows-input-wallboard-settings" [label]="'realtime:wallboard_maxrows' | i18next " [(model)]="model.maxRows" width="200px"
                (modelChange)="onDisplaySettingsChange()" [errorText]="maxRowsError" [hasError]="maxRowsError"></app-basic-textbox>
            </div>
            <div class="form-row">
              <app-basic-textbox id="footer-text-input-wallboard-settings" [label]="'realtime:wallboard_footertext' | i18next " [(model)]="model.footerText" width="400px"
                (modelChange)="onDisplaySettingsChange()"  [errorText]="footerTextError" [hasError]="footerTextError"></app-basic-textbox>
              <app-basic-dropdown id="font-dropdown-wallboard-settings" [(model)]="model.wallboardFontFamily" [items]="fontOptions" bindLabel="label" width="400px" appendTo=".popup-wallboard-settings"
                bindValue="value" [label]="'realtime:wallboard_SelectFont' | i18next" (modelChange)="onDisplaySettingsChange()" >
              </app-basic-dropdown>
            </div>
            <!-- Background Color Selection -->
            <div class="form-row form-color-row">
              <div class="color-section">
                <div>
                  {{ 'realtime:wallboard_PredefinedBackgroundColor' | i18next }}
                </div>
                <div>
                  <div *ngFor="let color of predefinedBackgroundColors">
                    <app-basic-radio id="radio-bg-color-{{color}}-wallboard-settings" [value]="color" [model]="model.wallboardBackgroundColor"
                      (change)="selectBackgroundColor(color)"></app-basic-radio>
                    <div class="color-ico" [style.background-color]="color" (click)="selectBackgroundColor(color)">
                    </div>
                  </div>
                </div>
              </div>
              <div class="color-section">
                <div>{{ 'realtime:wallboard_CustomBackgroundColor' | i18next }}</div>
                <div>
                  <div>
                    <app-basic-radio id="radio-custom-bg-color-wallboard-settings" [model]="isCustomBackgroundColor()" [value]="true"
                      (change)="selectCustomBackgroundColor()"></app-basic-radio>
                    <input id="custom-bg-color-input-wallboard-settings" type="color" [(ngModel)]="customBackgroundColor" (change)="selectCustomBackgroundColor()"
                      [style.background-color]="customBackgroundColor" />
                  </div>
                </div>
              </div>
            </div>
            <!-- Text Color Selection -->
            <div class="form-row form-color-row">
              <div class="color-section">
                <div>
                  {{ 'realtime:wallboard_PredefinedTxtColor' | i18next }}
                </div>
                <div>
                  <div *ngFor="let color of predefinedTextColors">
                    <app-basic-radio id="radio-text-color-{{color}}-wallboard-settings" [value]="color" [model]="model.wallboardTextColor"
                      (change)="selectTextColor(color)"></app-basic-radio>
                    <div class="color-ico" [style.background-color]="color" (click)="selectTextColor(color)"></div>
                  </div>
                </div>
              </div>
              <div class="color-section">
                <div>{{ 'realtime:wallboard_CustomTextColor' | i18next }}</div>
                <div>
                  <div>
                    <app-basic-radio id="radio-custom-text-color-wallboard-settings" [model]="isCustomTextColor()" [value]="true"
                      (change)="selectCustomTextColor()"></app-basic-radio>
                    <input id="custom-text-color-input-wallboard-settings" type="color" [(ngModel)]="customTextColor" (change)="selectCustomTextColor()"
                      [style.background-color]="customTextColor" />
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div class="actions">
          <app-basic-button id="reset-default-btn-wallboard-settings" type="secondary" size="small" (click)="resetToDefaultSettings()" >
           <i class="button-icon fas fa-undo fa-sm" style="margin-right: 4px;"></i> {{ 'realtime:wallboard_DefaultButton' | i18next }}
          </app-basic-button>
          <app-basic-button id="undo-display-btn-wallboard-settings" type="secondary" size="small" (click)="undoDisplayChanges()" [disabled]="!hasDisplayChanges">
            {{'Undo changes' | i18next }}
          </app-basic-button>
         <app-basic-button id="save-display-btn-wallboard-settings" type="primary" size="small" (click)="saveDisplaySettings()" [disabled]="!hasDisplayChanges || maxRowsError || footerTextError">
            {{'realtime:queuedetails_lang_savechanges' | i18next}}
          </app-basic-button>
        </div>
        <div class="error-pane" id="displayErrorPane" *ngIf="displayError">
          {{ displayError }}
        </div>
      </div>
    </div>
  </div>
</div>
